function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M128 10.24C63.024 10.24 10.24 63.024 10.24 128S63.024 245.76 128 245.76 245.76 192.976 245.76 128 192.976 10.24 128 10.24zm0 10.24c59.442 0 107.52 48.078 107.52 107.52 0 59.442-48.078 107.52-107.52 107.52-59.442 0-107.52-48.078-107.52-107.52C20.48 68.558 68.558 20.48 128 20.48zm0 35.84c-8.483 0-15.36 6.877-15.36 15.36s6.877 15.36 15.36 15.36 15.36-6.877 15.36-15.36-6.877-15.36-15.36-15.36zm-20.48 51.2v10.24h10.24v66.56h-10.24v10.24H148.48v-10.24h-10.24v-76.8h-25.6z",
  fill: "#fff",
  strokeMiterlimit: 10,
  fontFamily: "none",
  fontWeight: "none",
  fontSize: "none",
  textAnchor: "none"
});

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256"
  }, props), _ref);
}

export default SvgInfo;